var map = {
	"./collect-ip": [
		"a9c3",
		"chunk-2d209b1e"
	],
	"./collect-ip.md": [
		"a9c3",
		"chunk-2d209b1e"
	],
	"./create-api-keys": [
		"0371",
		"chunk-2d0a3913"
	],
	"./create-api-keys.md": [
		"0371",
		"chunk-2d0a3913"
	],
	"./create-webhook-business": [
		"dceb",
		"chunk-2d229652"
	],
	"./create-webhook-business.md": [
		"dceb",
		"chunk-2d229652"
	],
	"./create-webhook-legendary": [
		"63dc",
		"chunk-2d0cf8f2"
	],
	"./create-webhook-legendary.md": [
		"63dc",
		"chunk-2d0cf8f2"
	],
	"./embedded-notifications": [
		"07bd",
		"chunk-2d0a4d7f"
	],
	"./embedded-notifications.md": [
		"07bd",
		"chunk-2d0a4d7f"
	],
	"./embedded-transparent-background": [
		"fbad",
		"chunk-2d237ad5"
	],
	"./embedded-transparent-background.md": [
		"fbad",
		"chunk-2d237ad5"
	],
	"./instant-notification-emails-addresses-business": [
		"cd90",
		"chunk-2d22202e"
	],
	"./instant-notification-emails-addresses-business.md": [
		"cd90",
		"chunk-2d22202e"
	],
	"./instant-notification-emails-addresses-legendary": [
		"3ec4",
		"chunk-2d0c5739"
	],
	"./instant-notification-emails-addresses-legendary.md": [
		"3ec4",
		"chunk-2d0c5739"
	],
	"./integrations-google-sheets": [
		"31c3",
		"chunk-2d0b9404"
	],
	"./integrations-google-sheets.md": [
		"31c3",
		"chunk-2d0b9404"
	],
	"./integrations-mailchimp": [
		"4aeb",
		"chunk-2d0cbd00"
	],
	"./integrations-mailchimp.md": [
		"4aeb",
		"chunk-2d0cbd00"
	],
	"./integrations-salesforce": [
		"7999",
		"chunk-2d0d7e78"
	],
	"./integrations-salesforce.md": [
		"7999",
		"chunk-2d0d7e78"
	],
	"./kiosk-mode": [
		"6b00",
		"chunk-2d0da2e2"
	],
	"./kiosk-mode.md": [
		"6b00",
		"chunk-2d0da2e2"
	],
	"./summary-notification-emails-addresses-business": [
		"1aa2",
		"chunk-2d0b5f37"
	],
	"./summary-notification-emails-addresses-business.md": [
		"1aa2",
		"chunk-2d0b5f37"
	],
	"./summary-notification-emails-addresses-legendary": [
		"fc74",
		"chunk-2d237950"
	],
	"./summary-notification-emails-addresses-legendary.md": [
		"fc74",
		"chunk-2d237950"
	],
	"./survey-notifications": [
		"ed2a",
		"chunk-2d230844"
	],
	"./survey-notifications.md": [
		"ed2a",
		"chunk-2d230844"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "354b";
module.exports = webpackAsyncContext;